module.exports = __webpack_public_path__ + "img/cert3.107c283f.png";